<template>
  <v-app>
    <!-- barra de navegacion usuario autenticado -->
    <NavBarLogued v-if="auth"></NavBarLogued>

    <!-- barra de navegacion usuario sin autenticar -->
    <NavBarLogout v-if="!auth"></NavBarLogout>
    <Loader v-if="loading.state"></Loader>
    <v-main style="margin-left: 64px; margin-top: 50px;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import {mapState, mapMutations} from 'vuex'
import NavBarLogued from '@/components/NavBarLogued.vue'
import NavBarLogout from '@/components/NavBarLogout.vue'
import Loader from '@/components/Loader.vue'
export default {
  name: 'App',
  data: () => ({
    //
  }),
  mounted() {
    this.detectarIP();
    //console.log(`proccess.env.BASE_URL:${process.env.BASE_URL}`);
    this.socket.on('connect',()=>{
      console.log(`conectado al socket:${this.url_socket}`);
    });
    this.socket.on('disconnect',()=>{
      console.log(`Socket desconectado`);
    });
  },
  methods: {
    detectarIP(){
      let url_actual = window.location.href
      //condicion para produccion
      let backend = process.env.VUE_APP_BACKEND_LOCAL;
      /*if(url_actual.includes("190.13.184.67")){
        backend = process.env.VUE_APP_BACKEND_EXTERNAL
      }else{
        backend = process.env.VUE_APP_BACKEND_LOCAL
      }*/

      this.actualizarBaseUrl(`${backend}/api/`);
      this.actualizarDownloadUrl(`${backend}/archivos/bitacoras/`);

      //console.log('url actual',url_actual);
      //console.log('backend',backend);

      /*if(url_actual.includes('localhost') || url_actual.includes('192.168.1.164') || url_actual.includes('192.168.205.196')){
          //backend local fermin (no borrar)
          this.actualizarBaseUrl('http://localhost/produccion-plp/backend/public/api/');
          this.actualizarDownloadUrl('http://localhost/produccion-plp/backend/public/archivos/bitacoras/');
          this.actualizarUrlSocket('localhost:3000');
      }else if(url_actual.includes('192.168.205.150')){
        //esta en la red local de producción
        this.actualizarBaseUrl('https://192.168.205.150/produccion-plp/backend/public/api/');
        this.actualizarDownloadUrl('https://192.168.205.150/produccion-plp/backend/public/archivos/bitacoras/');
        this.actualizarUrlSocket('https://192.168.205.150:3001');
      }else if(url_actual.includes('190.13.184.67')){
        //se esta accediendo desde fuera de la red de producción
        this.actualizarBaseUrl('https://190.13.184.67/produccion-plp/backend/public/api/');
        this.actualizarDownloadUrl('https://190.13.184.67/produccion-plp/backend/public/archivos/bitacoras/');
        this.actualizarUrlSocket('https://190.13.184.67:3001');
      }else if(url_actual.includes('http://192.168.1.206:8080')){
        //se esta accediendo desde fuera de la red de producción
        this.actualizarBaseUrl('http://192.168.1.206/produccion-plp/backend/public/api/');
        this.actualizarDownloadUrl('http://192.168.1.206/produccion-plp/backend/public/archivos/bitacoras/');
        this.actualizarUrlSocket('https://localhost:3000');
      }else if(url_actual.includes(':83')){
        this.actualizarBaseUrl('http://192.168.1.164:81/api/');
      }*/
    },
    ...mapMutations(['actualizarBaseUrl', 'actualizarUrlSocket', 'actualizarDownloadUrl'])
  },
  computed:{
    ...mapState({
      auth:state => state.authenticated,
      roles:state => state.roles_prod,
      token:state => state.token,
      loading:state=> state.loading,
      url_socket: state => state.url_socket
    })
  },
  components:{
    NavBarLogued,
    NavBarLogout,
    Loader
  }
};
</script>
<!--  00897B 004D40 -->
<style>
  .titulopagina{
    background-color: #008000 !important; 
    color:white;
    border-color: #004D40 !important;
    letter-spacing: 0.2em !important;
    word-spacing: 0.5em;
    margin-bottom: 14px;
    padding: 2px 10px !important;
    box-shadow: -10px 8px #bcd4e6;
    border-radius: 5px;
  }
.container{max-width: 95%;}
</style>